<template lang="pug">
div
  .text-2xl.font-semibold.mb-4 Purchases
  v-row.mb-4(no-gutters)
    v-col.pr-4(cols="8")
      //- TODO: Re-enable Payment + Transfers redesigned card when stock transfer feature is ready
        v-card.border.rounded-lg.pa-4(outlined)
          v-row(no-gutters)
            v-col.pa-2
              .text-md.font-semibold.mb-5 Payment
              .d-flex.align-center.justify-space-between
                .text-sm Due
                .d-flex.align-center
                  template(v-if="purchasesMetaData.isFetching")
                    v-progress-circular(indeterminate size="17" color="primary" width="2")
                  div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.paymentDue === null")
                    v-icon(size="17" color="danger500") mdi-cancel
                  .text-sm.font-semibold(v-else) {{ purchasesMetaData.data.paymentDue | displayPrice }}
                  v-icon.ml-2(size="11" color="warning500") $yzi-circle

              yz-divider.my-1

              .d-flex.align-center.justify-space-between
                .text-sm Overdue
                .d-flex.align-center
                  template(v-if="purchasesMetaData.isFetching")
                    v-progress-circular(indeterminate size="17" color="primary" width="2")
                  div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.paymentOverdue === null")
                    v-icon(size="17" color="danger500") mdi-cancel
                  .text-sm.font-semibold.danger500--text(v-else) {{ purchasesMetaData.data.paymentOverdue | displayPrice }}
                  v-icon.ml-2(size="11" color="danger") $yzi-circle

              yz-divider.my-1

              .d-flex.align-center.justify-space-between
                .text-sm Paid
                .d-flex.align-center
                  template(v-if="purchasesMetaData.isFetching")
                    v-progress-circular(indeterminate size="17" color="primary" width="2")
                  div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.paymentPaid === null")
                    v-icon(size="17" color="danger500") mdi-cancel
                  .text-sm.font-semibold(v-else) {{ purchasesMetaData.data.paymentPaid | displayPrice }}
                  v-icon.ml-2(size="11" color="success") $yzi-circle

            v-divider.mx-2(vertical)

            v-col.pa-2
              .text-md.font-semibold.mb-5 Transfers
              .d-flex.align-center.justify-space-between
                .text-sm Total active requests
                .d-flex.align-center
                  template(v-if="purchasesMetaData.isFetching")
                    v-progress-circular(indeterminate size="17" color="primary" width="2")
                  div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.transferActiveRequests === null")
                    v-icon(size="17" color="danger500") mdi-cancel
                  .text-sm.font-semibold(v-else) {{ purchasesMetaData.data.transferActiveRequests }} {{ 'request' | pluralize({ count: purchasesMetaData.data.transferActiveRequests }) }}
                  v-icon.ml-2(size="11" color="warning500") $yzi-circle

              yz-divider.my-1

              .d-flex.align-center.justify-space-between
                .text-sm Total active pending approval
                .d-flex.align-center
                  template(v-if="purchasesMetaData.isFetching")
                    v-progress-circular(indeterminate size="17" color="primary" width="2")
                  div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.transferPendingApproval === null")
                    v-icon(size="17" color="danger500") mdi-cancel
                  .text-sm.font-semibold(v-else) {{ purchasesMetaData.data.transferPendingApproval }} approval
                  v-icon.ml-2(size="11" color="success") $yzi-circle

              yz-divider.my-1

              .d-flex.align-center.justify-space-between
                .text-sm Fully received
                .d-flex.align-center
                  template(v-if="purchasesMetaData.isFetching")
                    v-progress-circular(indeterminate size="17" color="primary" width="2")
                  div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.transferFullyReceived === null")
                    v-icon(size="17" color="danger500") mdi-cancel
                  .text-sm.font-semibold(v-else) {{ purchasesMetaData.data.transferFullyReceived }} {{ 'request' | pluralize({ count: purchasesMetaData.data.transferFullyReceived }) }}
                  v-icon.ml-2(size="11" color="info") $yzi-circle
      v-card.border.rounded-lg.pa-6.info-height(outlined style="height: 100%;")
        .text-md.font-semibold.mb-5 Payment
        v-row(no-gutters)
          v-col
            .text-sm Due
            .d-flex.align-center
              v-icon.mr-2(size="11" color="warning500") $yzi-circle
              template(v-if="purchasesMetaData.isFetching")
                v-progress-circular.ml-2.mt-2(indeterminate size="17" color="primary" width="2")
              div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.paymentDue === null")
                v-icon(size="17" color="danger500") mdi-cancel
                .text-xxs Error fetching data
              .text-xl.font-gotham-rounded.font-weight-350(v-else) {{ purchasesMetaData.data.paymentDue | displayPrice }}
          v-divider.mx-4(vertical)
          v-col
            .text-sm Overdue
            .d-flex.align-center
              v-icon.mr-2(size="11" color="danger") $yzi-circle
              template(v-if="purchasesMetaData.isFetching")
                v-progress-circular.ml-2.mt-2(indeterminate size="17" color="primary" width="2")
              div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.paymentOverdue === null")
                v-icon(size="17" color="danger500") mdi-cancel
                .text-xxs Error fetching data
              .text-xl.font-gotham-rounded.font-weight-350(v-else) {{ purchasesMetaData.data.paymentOverdue | displayPrice }}
          v-divider.mx-4(vertical)
          v-col
            .text-sm Paid
            .d-flex.align-center
              v-icon.mr-2(size="11" color="success") $yzi-circle
              template(v-if="purchasesMetaData.isFetching")
                v-progress-circular.ml-2.mt-2(indeterminate size="17" color="primary" width="2")
              div.danger500--text(v-else-if="purchasesMetaData.isError || purchasesMetaData.data.paymentPaid === null")
                v-icon(size="17" color="danger500") mdi-cancel
                .text-xxs Error fetching data
              .text-xl.font-gotham-rounded.font-weight-350(v-else) {{ purchasesMetaData.data.paymentPaid | displayPrice }}
    v-col(cols="4")
      v-card.border.rounded-lg.pa-4(outlined style="height: 100%;")
        .pa-2
          .text-md.font-semibold.mb-4 Inventory
          .mb-1.d-flex.align-center
            template(v-if="purchasesMetaData.isFetching")
              v-skeleton-loader(width="100%" type="text" height="10")
            template(v-else)
              .text-xxs.danger500--text.d-flex.align-center(v-if="purchasesMetaData.isError || purchasesMetaData.data.stockReceived === null")
                v-icon.mr-2(size="17" color="danger500") mdi-cancel
                span Error fetching stock received data
              span.text-xl.font-gotham-rounded.font-weight-350(v-else)
                span {{ purchasesMetaData.data.stockReceived }}&nbsp;
                span.neutral500--text stock received
          .d-flex.align-center.justify-space-between.mb-1
            template(v-if="purchasesMetaData.isFetching")
              v-skeleton-loader(width="100%" type="text" height="10")
            template(v-else)
              .text-xxs.danger500--text.d-flex.align-center(v-if="purchasesMetaData.isError || purchasesMetaData.data.stockRequested === null")
                v-icon.mr-2(size="17" color="danger500") mdi-cancel
                span Error fetching stock pending data
              template(v-else)
                .text-xs out of {{ purchasesMetaData.data.stockRequested }} stock pending
                .text-xs {{ calcRequestStockPercentage() }}%
          template(v-if="purchasesMetaData.isFetching")
            v-skeleton-loader.mt-2(width="100%" type="text" height="10")
          template(v-else-if="!purchasesMetaData.isError && purchasesMetaData.data.stockReceived !== null && purchasesMetaData.data.stockRequested !== null")
            v-progress-linear.rounded-lg(height="12" :value="calcRequestStockPercentage()" color="success")
  v-card.border.rounded-lg(outlined)
    div.pa-1
    v-row.pb-2.pb-md-0.px-4(no-gutters)
      v-col(cols="12" md="8")
        v-tabs(v-model="tab" color="basic700" :height="44" show-arrows active-class="font-semibold")
          v-tab.text-sm.font-medium.text-none(v-for="eachTab in tabs" :key="eachTab.id") {{ eachTab.text }}
      v-col(cols="12" md="4" align="end")
        .d-flex.align-center
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          div(v-if="selectedTabId !== 'stockTransfer'")
            customize-column-menu(v-if="selectedTabId === 'quotation'" type="purchase_hub_quotation" :showTooltip="false" iconSize="21")
            customize-column-menu(v-if="selectedTabId === 'purchaseOrder'" type="purchase_hub_order" :showTooltip="false" iconSize="21")
            customize-column-menu(v-if="selectedTabId === 'invoice'" type="purchase_hub_invoice" :showTooltip="false" iconSize="21")
          v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="openAddNewSelectDocumentTypeDialog = true") Create new
    v-divider
    //- Filters
    .px-4
      quotation-filter-row.mt-2(v-if="selectedTabId === 'quotation'" :filters.sync="filters.quotation" ref="filter")
      stock-transfer-filter-row.mt-2(v-if="selectedTabId === 'stockTransfer'" :filters.sync="filters.stockTransfer" ref="filter")
      purchase-order-filter-row.mt-4(v-if="selectedTabId === 'purchaseOrder'" :filters.sync="filters.purchaseOrder" ref="filter")
      invoice-filter-row.mt-4(v-if="selectedTabId === 'invoice'" :filters.sync="filters.invoice" ref="filter")
    //- Table
    v-data-table.mt-4.pb-6(:headers="headers" :items="items.data" item-key="id" :items-per-page="pageSize" :loading="items.isFetching" disable-sort hide-default-footer loader-height="2" @click:row="handleRowClick")
      template(v-slot:item.dateIssued="{ item }")
        .text-no-wrap {{ item.dateIssued }}
      template(v-slot:item.dueDate="{ item }")
        .text-no-wrap {{ item.dueDate }}
      template(v-slot:item.location="{ item }")
        v-tooltip(top color="black" content-class="black tooltip-top-arrow")
          template(#activator="{ on, attrs }")
            .text-truncate(v-bind="attrs" v-on="on" style="max-width: 160px;") {{ item.location }}
          span {{ item.location }}
      template(v-slot:item.sendTo="{ item }")
        v-tooltip(top color="black" content-class="black tooltip-top-arrow")
          template(#activator="{ on, attrs }")
            .text-truncate(v-bind="attrs" v-on="on" style="max-width: 160px;") {{ item.sendTo }}
          span {{ item.sendTo }}
      template(v-slot:item.type="{ item }")
        y-chip.type-chip(:label="item.type" :color="getTypeColor(item.type)" outlined size="xs")
      template(v-slot:item.requestStatus="{ item }")
        request-status-chip(:status="item.requestStatus")
      template(v-slot:item.orderStatus="{ item }")
        order-status-chip(:status="item.orderStatus")
      template(v-slot:item.inventoryStatus="{ item }")
        inventory-status-chip(:status="item.inventoryStatus")
      template(v-slot:item.paymentStatus="{ item }")
        payment-status-chip(:status="item.paymentStatus")
      template(v-slot:item.action="{ item }")
        v-menu(offset-y left rounded="lg" attach)
          template(v-slot:activator="{ on }")
            v-btn(icon small v-on="on")
              v-icon mdi-dots-horizontal
          v-list
            v-list-item(v-for="action in getActions(item)" :key="action.value" @click.stop="handleSelectedItemAction(item, action.value)")
              v-list-item-title.text-sm(:class="[action.value === 'archive' ? 'danger500--text' : 'neutral700--text']") {{ action.text }}
      template(v-slot:no-data)
        div.my-2(v-if="items.isError")
          v-icon(color="danger500") mdi-alert-circle
          .text-sm.danger500--text An error occurred while fetching data
        yz-empty-state-card.my-6(v-else-if="selectedTabId === 'stockTransfer'" title="No stock transfers" description="Stock transfer records will appear here")
        div(v-else) No data available
    div.d-flex.justify-end(v-if="items.totalCount > pageSize")
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="items.totalCount" attach menu-top @input="pageChanged")
  .dialogs
    add-new-select-document-type-dialog(v-if="openAddNewSelectDocumentTypeDialog" :open.sync="openAddNewSelectDocumentTypeDialog" @selected="handleCreateNewDocument")
    add-edit-document-dialog(v-if="openDocumentDialog" :open.sync="openDocumentDialog" :parentId="selectedItemId" :selectedDocument="selectedDocument" @updated="fetchItems" @closed="handleCloseDocumentDialog")
    document-archive-confirmation-dialog(v-if="openDocumentArchiveConfirmationDialog" :open.sync="openDocumentArchiveConfirmationDialog" :selectedDocument="selectedDocument" :parentId="selectedItemId" @updated="fetchItems" @closed="handleCloseDocumentDialog")
    document-unarchive-confirmation-dialog(v-if="openDocumentUnarchiveConfirmationDialog" :open.sync="openDocumentUnarchiveConfirmationDialog" :selectedDocument="selectedDocument" :parentId="selectedItemId" @updated="fetchItems" @closed="handleCloseDocumentDialog")
    document-create-and-mark-ordered-confirmation-dialog(v-if="documentCreateAndMarkOrderedConfirmation.openDialog" :open.sync="documentCreateAndMarkOrderedConfirmation.openDialog" :loading="documentCreateAndMarkOrderedConfirmation.isLoading" @confirmed="handleConfirmedCreateAndMarkOrdered")
    document-complete-order-confirmation-dialog(v-if="documentCompleteOrderConfirmation.openDialog" :open.sync="documentCompleteOrderConfirmation.openDialog" :loading="documentCompleteOrderConfirmation.isLoading" :selectedItem="selectedItem" @confirmed="handleConfirmedCompleteOrder")
    document-undo-completion-confirmation-dialog(v-if="documentUndoCompletionConfirmation.openDialog" :open.sync="documentUndoCompletionConfirmation.openDialog" :loading="documentUndoCompletionConfirmation.isLoading" @confirmed="handleConfirmedUndoCompletion")
</template>

<script>
import { debounce } from "@/utils"
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import RequestStatusChip from '@/components/clinic/purchasehub/statuschip/RequestStatusChip.vue'
import OrderStatusChip from '@/components/clinic/purchasehub/statuschip/OrderStatusChip.vue'
import InventoryStatusChip from '@/components/clinic/purchasehub/statuschip/InventoryStatusChip.vue'
import PaymentStatusChip from '@/components/clinic/purchasehub/statuschip/PaymentStatusChip.vue'
import AddNewSelectDocumentTypeDialog from '@/components/clinic/dialogs/purchasehub/AddNewSelectDocumentTypeDialog.vue'
import AddEditDocumentDialog from '@/components/clinic/dialogs/purchasehub/AddEditDocumentDialog.vue'
import DocumentArchiveConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentArchiveConfirmationDialog.vue'
import DocumentUnarchiveConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentUnarchiveConfirmationDialog.vue'
import DocumentCreateAndMarkOrderedConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentCreateAndMarkOrderedConfirmationDialog.vue'
import DocumentCompleteOrderConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentCompleteOrderConfirmationDialog.vue'
import DocumentUndoCompletionConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentUndoCompletionConfirmationDialog.vue'
import QuotationFilterRow from '@/components/clinic/purchasehub/filters/QuotationFilterRow.vue'
import PurchaseOrderFilterRow from '@/components/clinic/purchasehub/filters/PurchaseOrderFilterRow.vue'
import InvoiceFilterRow from '@/components/clinic/purchasehub/filters/InvoiceFilterRow.vue'
import StockTransferFilterRow from '@/components/clinic/purchasehub/filters/StockTransferFilterRow.vue'

export default {
  components: {
    CustomizeColumnMenu, RequestStatusChip, OrderStatusChip, InventoryStatusChip, PaymentStatusChip, AddNewSelectDocumentTypeDialog, AddEditDocumentDialog,
    DocumentArchiveConfirmationDialog, DocumentUnarchiveConfirmationDialog, DocumentCreateAndMarkOrderedConfirmationDialog, DocumentCompleteOrderConfirmationDialog,
    DocumentUndoCompletionConfirmationDialog, QuotationFilterRow, PurchaseOrderFilterRow, InvoiceFilterRow, StockTransferFilterRow
  },
  props: {
    purchasesMetaData: {
      type: Object,
      required: true,
    },
    locationFilter: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      isFetching: false,
      items: {
        isFetching: false,
        isError: false,
        totalCount: 0,
        data: []
      },
      tab: 0,
      tabs: [
        { text: 'Quotation', id: 'quotation' },
        // TODO: Re-enable Stock transfer tab when feature is ready
        // { text: 'Stock transfer', id: 'stockTransfer' },
        { text: 'Purchase order', id: 'purchaseOrder' },
        { text: 'Invoice', id: 'invoice' },
      ],
      showSearchField: false,
      searchText: null,
      pageSize: 20,
      currentPage: 1,
      openAddNewSelectDocumentTypeDialog: false,
      selectedDocument: null,
      openDocumentDialog: false,
      selectedItem: null,
      openDocumentArchiveConfirmationDialog: false,
      openDocumentUnarchiveConfirmationDialog: false,
      documentCreateAndMarkOrderedConfirmation: {
        openDialog: false,
        isLoading: false,
      },
      documentCompleteOrderConfirmation: {
        openDialog: false,
        isLoading: false,
      },
      documentUndoCompletionConfirmation: {
        openDialog: false,
        isLoading: false,
      },
      stockTransferFields: [
        { id: 'rid', field_name: 'ID', enable: true },
        { id: 'type', field_name: 'Type', enable: true },
        { id: 'requestedBy', field_name: 'Requested by', enable: true },
        { id: 'location', field_name: 'Location', enable: false, hqOnly: true },
        { id: 'sendTo', field_name: 'Send to', enable: true },
        { id: 'dateIssued', field_name: 'Date issued', enable: true },
        { id: 'requestStatus', field_name: 'Request status', enable: true },
        { id: 'inventoryStatus', field_name: 'Inventory status', enable: true },
        { id: 'unpaidBalance', field_name: 'Unpaid balance', enable: true },
        { id: 'reference', field_name: 'Reference', enable: true },
        { id: 'dueDate', field_name: 'Due date', enable: true },
        { id: 'remarks', field_name: 'Remarks', enable: true },
      ],
      filters: {
        quotation: [],
        purchaseOrder: [],
        invoice: [],
        stockTransfer: [],
      },
      quotation: {
        actions: {
          draft: [
            {
              text: 'Continue',
              value: 'continue',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          created: [
            {
              text: 'Edit',
              value: 'edit',
            },
            {
              text: 'Update to PO',
              value: 'updateToPO',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          archived: [
            {
              text: 'View details',
              value: 'view',
            },
            // {
            //   text: 'Unarchive',
            //   value: 'unarchive',
            // }
          ]
        }
      },
      purchaseOrder: {
        actions: {
          draft: [
            {
              text: 'Continue',
              value: 'continue',
            },
            {
              text: 'Save and mark ordered',
              value: 'saveAndMarkOrdered',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          active: [
            {
              text: 'Update',
              value: 'update',
            },
            {
              text: 'Complete order',
              value: 'completeOrder',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          completed: [
            {
              text: 'View details',
              value: 'view',
            },
            {
              text: 'Undo complete order',
              value: 'undoCompleteOrder',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          archived: [
            {
              text: 'View details',
              value: 'view',
            },
            // {
            //   text: 'Unarchive',
            //   value: 'unarchive',
            // }
          ]
        }
      },
      stockTransfer: {
        actions: {
          draft: [
            { text: 'View details', value: 'view' },
            { text: 'Archive', value: 'archive' },
          ],
          requested: [
            { text: 'View details', value: 'view' },
            { text: 'Archive', value: 'archive' },
          ],
          pending_approval: [
            { text: 'View details', value: 'view' },
            { text: 'Archive', value: 'archive' },
          ],
          approved: [
            { text: 'View details', value: 'view' },
            { text: 'Archive', value: 'archive' },
          ],
          rejected: [
            { text: 'View details', value: 'view' },
            { text: 'Archive', value: 'archive' },
          ],
          completed: [
            { text: 'View details', value: 'view' },
          ],
          archived: [
            { text: 'View details', value: 'view' },
          ],
        }
      },
      invoice: {
        actions: {
          draft: [
            {
              text: 'Continue',
              value: 'continue',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          active: [
            {
              text: 'Update',
              value: 'update',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          completed: [
            {
              text: 'View details',
              value: 'view',
            },
            {
              text: 'Undo complete invoice',
              value: 'undoCompleteInvoice',
            },
            {
              text: 'Archive',
              value: 'archive',
            }
          ],
          archived: [
            {
              text: 'View details',
              value: 'view',
            },
            // {
            //   text: 'Unarchive',
            //   value: 'unarchive',
            // }
          ]
        }
      }
    }
  },
  async mounted () {
    this.checkTabQuery()
    await this.fetchItems()
    this.checkIdQuery()
  },
  watch: {
    tab() {
      this.handleResetAllFilters()
      this.currentPage = 1
      this.items.data = []
      this.items.totalCount = 0
      this.fetchItems(false)
    },
    filters: {
      deep: true,
      handler() {
        this.fetchItems(false)
      }
    },
    locationFilter () {
      this.currentPage = 1
      this.fetchItems(false)
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      quotationFields: 'clinic/getPurchaseHubQuotationFields',
      orderFields: 'clinic/getPurchaseHubOrderFields',
      invoiceFields: 'clinic/getPurchaseHubInvoiceFields'
    }),
    selectedTabId () {
      return this.tabs[this.tab].id
    },
    endpoint () {
      switch (this.selectedTabId) {
        case 'quotation':
          return `/purchases/${this.company.slug}/quotations`

        case 'stockTransfer':
          return `/purchases/${this.company.slug}/stock-transfers`

        case 'purchaseOrder':
          return `/purchases/${this.company.slug}/orders`

        case 'invoice':
          return `/purchases/${this.company.slug}/invoices`

        default:
          return ''
      } 
    },
    params () {
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        search: this.searchText
      }
      switch (this.selectedTabId) {
        case 'quotation':
          this.filters.quotation.forEach(filter => {
            params[filter.key] = filter.value
          })
          break

        case 'stockTransfer':
          this.filters.stockTransfer.forEach(filter => {
            params[filter.key] = filter.value
          })
          break

        case 'purchaseOrder':
          this.filters.purchaseOrder.forEach(filter => {
            params[filter.key] = filter.value
          })
          break

        case 'invoice':
          this.filters.invoice.forEach(filter => {
            params[filter.key] = filter.value
          })
          break

        default:
          break
      }
      if (this.locationFilter && this.locationFilter.length > 0) {
        const ids = this.locationFilter.join(',')
        if (this.selectedTabId === 'stockTransfer') {
          params.locations = ids
        } else {
          params.source_companies = ids
          params.destination_companies = ids
        }
      }
      return params
    },
    headers() {
      let fields
      switch (this.selectedTabId) {
        case 'quotation':
          fields = this.quotationFields
          break

        case 'stockTransfer':
          fields = this.stockTransferFields.map(f => f.hqOnly ? { ...f, enable: this.isHq } : f)
          break

        case 'purchaseOrder':
          fields = this.orderFields
          break

        case 'invoice':
          fields = this.invoiceFields
          break
      
        default:
          fields = []
      }
      fields = fields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.id === 'type' ? '' : item.field_name,
        item.value = item.id
      })
      const actions = {
        text: 'action',
        value: 'action',
        enable: true,
        sortable: false,
      }
      return [...fields, actions]
    },
    selectedItemId () {
      return this.selectedItem?.id ?? null
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    getTypeColor (type) {
      switch (type) {
        case 'TRANSFER': return 'blue'
        case 'BRANCH': return 'blue'
        case 'SUPPLIER': return 'normal'
        case 'REQUEST': return 'normal'
        default: return 'normal'
      }
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchItems()
    }, 750),
    calcRequestStockPercentage () {
      return this.purchasesMetaData.data.stockRequested === 0 ? 0 : ((this.purchasesMetaData.data.stockReceived / this.purchasesMetaData.data.stockRequested) * 100).toFixed(0)
    },
    async fetchItems (emitUpdated = true) {
      try {
        this.items.isFetching = true
        const { data } = await this.axios.get(this.endpoint, { params: this.params })
        this.items.data = data.results.map(result => this.sanitizeData(result))
        this.items.totalCount = data.count
        this.items.isError = false
        if (emitUpdated) this.$emit('updated')
      } catch (error) {
        this.items.data = []
        this.items.totalCount = 0
        this.items.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.items.isFetching = false
      }
    },
    pageChanged () {
      this.fetchItems()
    },
    formatSendTo (company) {
      if (!company) return '-'
      let text = company.name || ''
      if (company.address) {
        const addr = company.address
        const parts = [addr.address_1, addr.city, addr.state].filter(Boolean)
        if (parts.length) text += ', ' + parts.join(', ')
      }
      return text || '-'
    },
    formatDate (date) {
      if (!date) return ''
      return DateTime.fromISO(date).toFormat('dd MMM y')
    },
    formatPrice (price) {
      return this.$options.filters.displayPrice(price)
    },
    sanitizeData (data) {
      switch (this.selectedTabId) {
        case 'quotation':
          return {
            detail: data,
            id: data.id,
            type: 'SUPPLIER',
            requestedBy: data.requested_by || '-',
            supplierName: data.supplier?.value || '-',
            sendTo: this.formatSendTo(data.destination_company),
            rid: data.rid,
            dateIssued: this.formatDate(data.record_date),
            requestStatus: data.request_status,
            remarks: data.remarks || '-',
          }

        case 'purchaseOrder':
          return {
            detail: data,
            id: data.id,
            type: 'SUPPLIER',
            requestedBy: data.requested_by || '-',
            supplierName: data.supplier?.value || '-',
            sendTo: this.formatSendTo(data.destination_company),
            rid: data.rid,
            orderStatus: data.order_status,
            inventoryStatus: data.inventory_status,
            paymentStatus: data.payment_status,
            remarks: data.remarks,
            unpaidBalance: this.formatPrice(data.total_amount - data.paid_amount),
            dateIssued: this.formatDate(data.record_date),
            dueDate: this.formatDate(data.due_date),
          }

        case 'stockTransfer':
          return {
            detail: data,
            id: data.id,
            rid: data.rid,
            type: data.type,
            requestedBy: data.requested_by || '-',
            location: this.formatSendTo(data.source_company),
            sendTo: data.type === 'REQUEST' ? this.formatSendTo(data.source_company) : this.formatSendTo(data.destination_company),
            dateIssued: this.formatDate(data.record_date),
            requestStatus: data.order_status,
            inventoryStatus: data.order_status === 'rejected' ? null : data.inventory_status,
            unpaidBalance: this.formatPrice(data.total_amount - data.paid_amount),
            reference: data.rid || '-',
            dueDate: this.formatDate(data.due_date),
            remarks: data.remarks || '-',
          }

        case 'invoice':
          return {
            detail: data,
            id: data.id,
            type: (data.source_company && data.destination_company) ? 'BRANCH' : 'SUPPLIER',
            requestedBy: data.requested_by || '-',
            supplierName: data.supplier?.value || '-',
            sendTo: this.formatSendTo(data.destination_company),
            invoiceNumber: data.invoice_number,
            rid: data.rid,
            dateIssued: this.formatDate(data.record_date),
            amount: this.formatPrice(data.total_amount),
            orderStatus: data.order_status,
            paymentStatus: data.payment_status,
            unpaidBalance: this.formatPrice(data.total_amount - data.paid_amount),
            dueDate: this.formatDate(data.due_date),
            remarks: data.remarks,
          }
      
        default:
          return data
      }
      
    },
    handleCreateNewDocument (document) {
      this.selectedDocument = document
      this.openAddNewSelectDocumentTypeDialog = false
      this.openDocumentDialog = true
    },
    getActions (item) {
      switch (this.selectedTabId) {
        case 'quotation':
          return this.quotation.actions[item.requestStatus]
        case 'stockTransfer':
          return this.stockTransfer.actions[item.requestStatus] || []
        case 'purchaseOrder':
          return this.purchaseOrder.actions[item.orderStatus]
        case 'invoice':
          return this.invoice.actions[item.orderStatus]
        default:
          return []
      }
    },
    handleSelectedItemAction (item, action) {
      this.selectedItem = item
      if (this.selectedTabId === 'quotation') {
        this.handleQuotationAction(action)
      }
      if (this.selectedTabId === 'stockTransfer') {
        this.handleStockTransferAction(action)
      }
      if (this.selectedTabId === 'purchaseOrder') {
        this.handlePurchaseOrderAction(action)
      }
      if (this.selectedTabId === 'invoice') {
        this.handleInvoiceAction(action)
      }
    },
    handleCloseDocumentDialog () {
      this.selectedItem = null
    },
    handleQuotationAction (action) {
      this.selectedDocument = {
        id: 'quotation'
      }
      switch (action) {
        case 'continue':
        case 'edit':
        case 'view':
          this.openDocumentDialog = true
          break

        case 'updateToPO':
          this.handleConvertToPurchaseOrder(this.selectedItem)
          break

        case 'archive':
          this.openDocumentArchiveConfirmationDialog = true
          break

        case 'unarchive':
          this.openDocumentUnarchiveConfirmationDialog = true
          break
      
        default:
          break
      }
    },
    handlePurchaseOrderAction (action) {
      this.selectedDocument = {
        id: 'purchase-order'
      }
      switch (action) {
        case 'continue':
        case 'update':
        case 'view':
          this.openDocumentDialog = true
          break

        case 'saveAndMarkOrdered':
          this.documentCreateAndMarkOrderedConfirmation.openDialog = true
          break
          
          case 'completeOrder':
          this.documentCompleteOrderConfirmation.openDialog = true
          break

        case 'undoCompleteOrder':
          this.documentUndoCompletionConfirmation.openDialog = true
          break

        case 'archive':
          this.openDocumentArchiveConfirmationDialog = true
          break

        case 'unarchive':
          this.openDocumentUnarchiveConfirmationDialog = true
          break
      
        default:
          break
      }
    },
    handleInvoiceAction (action) {
      this.selectedDocument = {
        id: 'invoice'
      }
      switch (action) {
        case 'continue':
        case 'update':
        case 'view':
          this.openDocumentDialog = true
          break

        case 'saveAndMarkOrdered':
          this.documentCreateAndMarkOrderedConfirmation.openDialog = true
          break
          
          case 'completeOrder':
          this.documentCompleteOrderConfirmation.openDialog = true
          break

        case 'undoCompleteInvoice':
          this.documentUndoCompletionConfirmation.openDialog = true
          break

        case 'archive':
          this.openDocumentArchiveConfirmationDialog = true
          break

        case 'unarchive':
          this.openDocumentUnarchiveConfirmationDialog = true
          break
      
        default:
          break
      }
    },
    handleStockTransferAction (action) {
      this.selectedDocument = { id: 'stock-transfer' }
      switch (action) {
        case 'view':
          this.openDocumentDialog = true
          break
        case 'archive':
          this.openDocumentArchiveConfirmationDialog = true
          break
        default:
          break
      }
    },
    async handleConfirmedCreateAndMarkOrdered () {
      try {
        this.documentCreateAndMarkOrderedConfirmation.isLoading = true
        const endpoint = `/purchases/${this.company.slug}/orders/${this.selectedItem.id}`
        const payload = {
          order_status: 'active'
        }
        await this.axios.patch(endpoint, payload)
        this.showMessage(['success', `Successfully update ${this.selectedDocument.id}`])
        this.updateActivityLog(endpoint, payload, null, 'PATCH', this.selectedItem.id)
        await this.fetchItems()
        this.documentCreateAndMarkOrderedConfirmation.openDialog = false
      } catch (error) {
        this.showMessage(['error', `Failed to update ${this.selectedDocument.id}`])
      } finally {
        this.documentCreateAndMarkOrderedConfirmation.isLoading = false
      }
    },
    async handleConfirmedCompleteOrder () {
      try {
        this.documentCompleteOrderConfirmation.isLoading = true
        const endpoint = `/purchases/${this.company.slug}/orders/${this.selectedItem.id}`
        const payload = {
          order_status: 'completed'
        }
        await this.axios.patch(endpoint, payload)
        this.showMessage(['success', `Successfully update ${this.selectedDocument.id}`])
        this.updateActivityLog(endpoint, payload, null, 'PATCH', this.selectedItem.id)
        await this.fetchItems()
        this.documentCompleteOrderConfirmation.openDialog = false
      } catch (error) {
        this.showMessage(['error', `Failed to update ${this.selectedDocument.id}`])
      } finally {
        this.documentCompleteOrderConfirmation.isLoading = false
      }
    },
    async handleConfirmedUndoCompletion () {
      try {
        this.documentUndoCompletionConfirmation.isLoading = true
        const ordersOrInvoices = this.selectedTabId === 'purchaseOrder' ? 'orders' : 'invoices'
        const endpoint = `/purchases/${this.company.slug}/${ordersOrInvoices}/${this.selectedItem.id}`
        const payload = {
          order_status: 'active'
        }
        await this.axios.patch(endpoint, payload)
        this.showMessage(['success', `Successfully update ${this.selectedDocument.id}`])
        this.updateActivityLog(endpoint, payload, null, 'PATCH', this.selectedItem.id)
        await this.fetchItems()
        this.documentUndoCompletionConfirmation.openDialog = false
      } catch (error) {
        this.showMessage(['error', `Failed to update ${this.selectedDocument.id}`])
      } finally {
        this.documentUndoCompletionConfirmation.isLoading = false
      }
    },
    async handleConvertToPurchaseOrder () {
      try {
        const endpoint = `/purchases/${this.company.slug}/quotations/${this.selectedItem.id}/convert_to_order`
        const resp = await this.axios.post(endpoint)
        this.updateActivityLog(endpoint, null, resp, 'POST', this.selectedItem.id, 'Quotation converted to purchase order')
        this.showMessage(['success', 'Successfully converted to purchase order'])
        await this.fetchItems()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    updateActivityLog (endpoint, payload, response, method, id, activity = null) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: activity ?? `${this.selectedDocument.id} ${method === 'POST' ? 'created' : 'updated'}`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    handleResetAllFilters () {
      this.filters.quotation = []
      this.filters.stockTransfer = []
      this.filters.purchaseOrder = []
      this.filters.invoice = []
    },
    handleRowClick (item) {
      this.handleSelectedItemAction(item, 'view')
    },
    checkTabQuery () {
      const tab = this.$route.query?.tab || null
      if (tab) {
        const index = this.tabs.findIndex(item => item.id.toLowerCase() === tab.toLowerCase())
        if (index >= 0) {
          this.tab = index
        }
      }
    },
    checkIdQuery () {
      const id = this.$route.query?.id || null
      if (id) {
        const selectedItem = this.items.data.find(item => item.id === parseInt(id))
        if (selectedItem) {
          this.handleSelectedItemAction(selectedItem, 'view')
        }
      }
    },
  },
}
</script>

<style scoped>
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important;
}
.type-chip {
  border-radius: 4px !important;
  font-weight: 500 !important;
  line-height: 16px !important;
}
</style>